import { Reducer } from 'redux'
import { createFilter } from 'redux-persist-transform-filter'

import { MeState, MeActionTypes } from './types'

export const FILTER_PERSISTOR = createFilter(
  'me',
  null,
  ['organization', 'policy', 'user'],
  'whitelist'
)

const INITIAL_STATE: MeState = {
  error: {},
  loading: {},
  organization: null,
  policy: null,
  qrCode: null,
  user: null
}

const reducer: Reducer<MeState> = (
  state = INITIAL_STATE,
  { payload, type }
) => {
  switch (type) {
    /**
     * ACCEPT UPDATED TERMS
     */
    case MeActionTypes.ACCEPT_UPDATED_TERMS:
      return {
        ...state,
        user: { ...state.user, agree_terms: true }
      }

    /**
     * CHANGE_PASSWORD
     */
    case MeActionTypes.CHANGE_PASSWORD:
      return {
        ...state,
        error: { ...state.error, changePassword: false },
        loading: { ...state.loading, changePassword: true }
      }
    case MeActionTypes.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: { ...state.loading, changePassword: false },
        user: { ...state.user, must_change_password: false }
      }
    case MeActionTypes.CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        error: { ...state.error, changePassword: true },
        loading: { ...state.loading, changePassword: false }
      }

    /**
     * GENERATE_QRCODE
     */
    case MeActionTypes.GENERATE_QRCODE:
      return {
        ...state,
        error: { ...state.error, qrCode: true },
        qrCode: null,
        loading: { ...state.loading, qrCode: true }
      }
    case MeActionTypes.GENERATE_QRCODE_SUCCESS:
      return {
        ...state,
        qrCode: payload.qrCode,
        loading: { ...state.loading, qrCode: false }
      }
    case MeActionTypes.GENERATE_QRCODE_FAILURE:
      return {
        ...state,
        error: { ...state.error, qrCode: false },
        loading: { ...state.loading, qrCode: false }
      }

    /**
     * GET_ME
     */
    case MeActionTypes.GET_ME:
      return {
        ...state,
        error: { ...state.error, user: false },
        loading: { ...state.loading, user: true }
      }
    case MeActionTypes.GET_ME_SUCCESS:
      return {
        ...state,
        loading: { ...state.loading, user: false },
        user: payload.user
      }
    case MeActionTypes.GET_ME_FAILURE:
      return {
        ...state,
        error: { ...state.error, user: true },
        loading: { ...state.loading, user: false }
      }

    /**
     * GET_ORGANIZATION
     */
    case MeActionTypes.GET_ORGANIZATION:
      return {
        ...state,
        error: { ...state.error, organization: false },
        loading: { ...state.loading, organization: true }
      }
    case MeActionTypes.GET_ORGANIZATION_SUCCESS:
      return {
        ...state,
        loading: { ...state.loading, organization: false },
        organization: payload.organization
      }
    case MeActionTypes.GET_ORGANIZATION_FAILURE:
      return {
        ...state,
        error: { ...state.error, organization: true },
        loading: { ...state.loading, organization: false }
      }

    /**
     * GET_POLICY
     */
    case MeActionTypes.GET_POLICY:
      return {
        ...state,
        error: { ...state.error, policy: false },
        loading: { ...state.loading, policy: true }
      }
    case MeActionTypes.GET_POLICY_SUCCESS:
      return {
        ...state,
        loading: { ...state.loading, policy: false },
        policy: payload.policy
      }
    case MeActionTypes.GET_POLICY_FAILURE:
      return {
        ...state,
        error: { ...state.error, policy: true },
        loading: { ...state.loading, policy: false }
      }

    /**
     * DEFAULT
     */
    default:
      return state
  }
}

export default reducer
